/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Message } from 'components';
import ContainerUserPaymentForm from 'components/UserPaymentForm';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useUpdateMemberCenterSubscriptionMutation } from 'store/api/version-api.slice';
import { showMessage } from 'store/slices/message.slice';

import PaymentStatusResult from './PaymentStatusResult';
import { styles } from './styles';

const PaymentInformation = ({ isOpen, handleClose }) => {
	const [isModalLoading, setModalLoading] = useState(true);
	const [paymentStatus, setPaymentStatus] = useState('');

	const [updateMemberCenterSubscription] = useUpdateMemberCenterSubscriptionMutation();

	const dispatch = useDispatch();

	const onCloseHandler = () => {
		handleClose?.();
		setModalLoading(true);
		setPaymentStatus('');
	};

	const dispatchMessage = ({ message, variant = 'success' }) =>
		dispatch(
			showMessage({
				message,
				variant
			})
		);

	const updateUserPayment = async data => {
		try {
			const response = await updateMemberCenterSubscription(data);

			if (response?.data?.result?.includes('APPROVED')) {
				dispatchMessage({
					message: 'Payment Succeed!'
				});
				setPaymentStatus('SUCCESS');
			} else {
				dispatchMessage({
					message: 'Payment Failed! Please, try again later',
					variant: 'error'
				});
				setPaymentStatus('ERROR');
			}
		} catch (e) {
			console.error('Error occurred', e);
			dispatchMessage({
				message: 'Payment Failed! Please, try again later',
				variant: 'error'
			});
			setPaymentStatus('ERROR');
		}
	};

	return (
		<>
			<Dialog open={isOpen} onClose={onCloseHandler} maxWidth="md" fullWidth={true} sx={styles.dialog}>
				{isModalLoading && (
					<Box sx={styles.centered}>
						<CircularProgress size={56} />
					</Box>
				)}
				<DialogTitle disableTypography>
					<Typography component={'span'} variant="h4" color="primary">
						User Payment
					</Typography>
					<IconButton aria-label="close" onClick={onCloseHandler} sx={styles.closeIcon}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				{['SUCCESS', 'ERROR'].includes(paymentStatus) ? (
					<PaymentStatusResult status={paymentStatus} />
				) : (
					<DialogContent sx={styles.dialogContent}>
						<ContainerUserPaymentForm onSubmitHandler={updateUserPayment} setLoading={setModalLoading} />
					</DialogContent>
				)}
			</Dialog>
			<Message />
		</>
	);
};

export default PaymentInformation;
